export const DEFAULT_PAGE_SEARCH = {
  current: 1,
  pageSize: 20,
  sortField: 'createdAt' as const,
  sortOrder: 'desc' as const
}
export const DEFAULT_SELECTOR_SEARCH = { current: 1, pageSize: 10 }
export const DEFAULT_RESOURCE_SEARCH = { current: 1, pageSize: 6 }

// 重复首项，避免受控排序进入未排序状态后被默认降序锁住。
export const CREATED_AT_SORT_DIRECTIONS: Array<'ascend' | 'descend'> = ['descend', 'ascend', 'descend']

/** 两字主操作 + 带图标的“更多”，为按钮间距与单元格留白预留宽度。 */
export const TABLE_ACTION_COLUMN = {
  align: 'center',
  title: '操作',
  valueType: 'option',
  fixed: 'right',
  search: false,
  width: '10rem'
} as const
